/**
 * A file for formatting stuff.
 */

export function formatCurrency(value) {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });

  return formatter.format(value);
}

/**
 * Escapes double quotes for strings to be sent in requests, etc.
 *
 * @see https://gist.github.com/getify/3667624
 *
 * @param  {String} value The value to escape.
 * @return {String}       The escaped value.
 */
export function escapeDoubleQuotes(value) {
  return value.replace(/\\([\s\S])|(")/g,"\\$1$2");
}

/** Used to map HTML entities to characters. */
const htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
}

/** Used to match HTML entities and HTML characters. */
const reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g
const reHasEscapedHtml = RegExp(reEscapedHtml.source)

/**
 * This method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;` and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped.
 *
 */
export function unescape(string) {
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, (entity) => htmlUnescapes[entity])
    : string
}
